import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export interface KsaSessionLimitTemplate {
	activeFrom: string;
	limitValue: number;
	limitPeriod: string;
}

export enum KsaSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
}

export enum KsaSessionLimitSuggestionAmounts {
	Daily = 24,
	Weekly = 168,
	Monthly = 720,
}

export enum KsaSessionLimitPeriodTranslationsEnum {
	Daily = "dailySessionLimit",
	Weekly = "weeklySessionLimit",
	Monthly = "monthlySessionLimit",
}

export interface KsaSessionLimitFormGroup extends UntypedFormGroup {
	controls: {
		sessionLimitAmount: UntypedFormControl;
		sessionLimitPeriod: UntypedFormControl;
	};
}
